import api from "../util/api";
import {
  notifyWarn,
  notifySuccess,
  notifyInfo,
} from "../components/message/message";
import { setLoading } from "../store/modules/globalLoading/actions";
import { maskDate } from "../util/masks";
import * as actions from "../store/modules/feriados/actions";

export async function getFeriados(page, pageSize, pesquisa) {
  let url = `feriado/paginado?pagina=${page}&registros=${pageSize}`;

  if (pesquisa?.nacional !== undefined && pesquisa?.nacional !== null) {
    url += `&nacional=${pesquisa.nacional}`;
  }
  if (pesquisa?.descricao) url += `&descricao=${pesquisa.descricao}`;
  if (pesquisa?.data) url += `&data=${pesquisa.data}`;

  setLoading(true);
  const data = await api.get(url);
  setLoading(false);

  if (!data.success) return;

  const registros = Array.isArray(data.content.registros)
    ? data.content.registros
    : [];

  const totalPaginas = data?.content?.totalPaginas ?? 0;

  const dataFormated = registros.map((feriado) => {
    return {
      ...feriado,
      nacional: feriado.nacional ? "Sim" : "Não",
      data: new Date(feriado.data),
    };
  });

  actions.setSelectedItems([]);
  actions.setItems(dataFormated);
  actions.setTotals(totalPaginas);
  actions.getAllItems({
    quantidade: data?.content?.quantidade,
    quantidadeTotal: data?.content?.quantidadeTotal,
    totalPaginas: data?.content?.totalPaginas,
    tamanhoPagina: data?.content?.tamanhoPagina,
  });
}

export async function getById(id) {
  setLoading(true);
  const data = await api.get(`feriado/${id}`);
  setLoading(false);

  if (!data.success) {
    return;
  }

  const dataFormated = {
    id: data.content.id,
    descricao: data.content.descricao,
    nacional: data.content.nacional,
    data: maskDate(data.content.data, "YYYY-MM-DD"),
  };

  actions.copy(dataFormated);
  actions.pesquisar(dataFormated);
}

export async function deleteFeriado(id) {
  setLoading(true);
  const data = await api.delete(`feriado/${id}`);
  setLoading(false);

  if (!data.success) {
    return;
  }

  notifySuccess("Feriado removido");
}

export async function updateFeriado(item, copy) {
  if (JSON.stringify(item) === JSON.stringify(copy)) {
    notifyInfo("Nada foi alterado");
    return;
  }
  const body = {
    data: item.data,
    descricao: item.descricao,
    nacional: item.nacional,
  };
  setLoading(true);
  const data = await api.put(`feriado/${item.id}`, body);
  setLoading(false);

  if (!data.success) {
    return;
  }

  notifySuccess("Feriado atualizado");
  actions.cleanRegister();
  actions.setActiveTab("Search");
  getFeriados();
}

export async function createFeriado(pesquisa) {
  if (pesquisa.data === "") {
    actions.setInvalid("data");
    return notifyWarn("Data do feriado nao pode estar em branco");
  }
  if (pesquisa.descricao === "") {
    actions.setInvalid("descricao");
    return notifyWarn("Descrição do feriado nao pode estar em branco");
  }
  if (pesquisa.nacional === "") {
    actions.setInvalid("data");
    notifyWarn("Data do feriado não pode estar em branco");
    return;
  }

  setLoading(true);
  const data = await api.post("feriado", pesquisa);
  setLoading(false);

  if (!data.success) {
    return;
  }

  notifySuccess("Feriado cadastrado");
  actions.cleanRegister();
  actions.setActiveTab("Search");
}
